import type { Chain } from '../chain';

type ChainInfo = {
  apiChainName: string;
  blockchainName: string;
  verifiedCredentialChainName: string;
  waasChainNameOverride?: string;
};

export const CHAINS_INFO_MAP: Record<Chain, ChainInfo> = {
  ALEO: {
    apiChainName: 'aleo',
    blockchainName: 'Aleo',
    verifiedCredentialChainName: 'aleo',
  },
  ALGO: {
    apiChainName: 'algo',
    blockchainName: 'Algorand',
    verifiedCredentialChainName: 'algorand',
  },
  APTOS: {
    apiChainName: 'aptos',
    blockchainName: 'Aptos',
    verifiedCredentialChainName: 'aptos',
  },
  BTC: {
    apiChainName: 'bitcoin',
    blockchainName: 'Bitcoin',
    verifiedCredentialChainName: 'bip122',
  },
  COSMOS: {
    apiChainName: 'cosmos',
    blockchainName: 'Cosmos',
    verifiedCredentialChainName: 'cosmos',
  },
  ECLIPSE: {
    apiChainName: 'eclipse',
    blockchainName: 'Eclipse',
    verifiedCredentialChainName: 'eclipse',
  },
  EVM: {
    apiChainName: 'evm',
    // eslint-disable-next-line custom-rules/ban-ethereum-eth-terms
    blockchainName: 'Ethereum',
    verifiedCredentialChainName: 'eip155',
  },
  FLOW: {
    apiChainName: 'flow',
    blockchainName: 'Flow',
    verifiedCredentialChainName: 'flow',
  },
  SOL: {
    apiChainName: 'solana',
    blockchainName: 'Solana',
    verifiedCredentialChainName: 'solana',
    waasChainNameOverride: 'SVM',
  },
  SPARK: {
    apiChainName: 'spark',
    blockchainName: 'Spark',
    verifiedCredentialChainName: 'spark',
  },
  STARK: {
    apiChainName: 'starknet',
    blockchainName: 'Starknet',
    verifiedCredentialChainName: 'starknet',
  },
  STELLAR: {
    apiChainName: 'stellar',
    blockchainName: 'Stellar',
    verifiedCredentialChainName: 'stellar',
  },
  SUI: {
    apiChainName: 'sui',
    blockchainName: 'Sui',
    verifiedCredentialChainName: 'sui',
  },
  TEMPO: {
    apiChainName: 'tempo',
    blockchainName: 'Tempo',
    verifiedCredentialChainName: 'tempo',
  },
  TON: {
    apiChainName: 'ton',
    blockchainName: 'TON',
    verifiedCredentialChainName: 'ton',
  },
  TRON: {
    apiChainName: 'tron',
    blockchainName: 'Tron',
    verifiedCredentialChainName: 'tron',
  },
};
